/* PP speed 30/10/2026: moved verbatim from layout/theme.liquid (end of <body>) so they are cached instead of re-sent in every page.
   1. pause off-screen tickers  2. cart drawer = modal dialog focus/Escape  3. menu keyboard-focus safety (#pp-menu-focus-safety). */
  (function(){
    var tickers=document.querySelectorAll('.ticker--animated');
    if(!tickers.length||!('IntersectionObserver' in window))return;
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){e.target.classList.toggle('is-offscreen',!e.isIntersecting);});
    },{rootMargin:'100px 0px'});
    tickers.forEach(function(t){io.observe(t);});
  })();

  /* PP 2026-10-27: the cart drawer is a modal dialog; move focus into it when it opens and let Escape close it. */
  (function () {
    var d = document.getElementById('drawer-cart');
    if (!d) return;
    new MutationObserver(function () {
      if (d.classList.contains('drawer--visible') && !d.contains(document.activeElement)) {
        var f = d.querySelector('[data-first-focus]');
        if (f) f.focus({ preventScroll: true });
      }
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !d.classList.contains('drawer--visible')) return;
      var c = d.querySelector('.drawer__close');
      if (c) c.click();
    });
  })();

  /* The menu must receive keyboard focus even when no CSS transition fires. */
  (function () {
    if (window.__ppMenuFocusSafety) return;
    var menu = document.getElementById('header-menu');
    if (!menu) return;
    window.__ppMenuFocusSafety = true;
    function isOpen() { return menu.classList.contains('drawer--visible'); }
    function controls() {
      return Array.prototype.filter.call(menu.querySelectorAll('a[href], button, input, select, textarea, [tabindex]'), function (el) {
        var panel = el.closest('[data-sliderule]');
        return !el.disabled && el.tabIndex >= 0 && !el.closest('[hidden], [inert], [aria-hidden="true"], .is-hidden') && (!panel || panel.classList.contains('is-visible')) && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
      });
    }
    function focusFirst() {
      var first = controls()[0];
      if (first) first.focus({ preventScroll: true });
    }
    new MutationObserver(function () {
      if (isOpen() && !menu.contains(document.activeElement)) focusFirst();
    }).observe(menu, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('focusin', function (event) {
      if (isOpen() && !menu.contains(event.target)) focusFirst();
    });
    document.addEventListener('keydown', function (event) {
      if (!isOpen()) return;
      if (event.key === 'Tab') {
        var items = controls();
        var first = items[0];
        var last = items[items.length - 1];
        if (first && (!menu.contains(document.activeElement) || (event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last))) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus({ preventScroll: true });
        }
      }
    }, true);
    /* Escape pressed in the first milliseconds after opening: the theme adds drawer--visible 1 ms after the click, so close, then close again if it reopens. */
    var clickedAt = 0;
    var closeAskedAt = 0;
    Array.prototype.forEach.call(document.querySelectorAll('[aria-controls="header-menu"]'), function (btn) {
      btn.addEventListener('click', function () { clickedAt = Date.now(); });
    });
    function closeMenu() { menu.dispatchEvent(new CustomEvent('theme:drawer:close', { bubbles: false })); }
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var expanded = !!document.querySelector('[aria-controls="header-menu"][aria-expanded="true"]');
      var opening = Date.now() - clickedAt < 600 && !menu.classList.contains('display-none');
      if (!isOpen() && !expanded && !opening) return;
      closeAskedAt = Date.now();
      closeMenu();
    });
    new MutationObserver(function () {
      if (closeAskedAt && Date.now() - closeAskedAt < 600 && isOpen()) { closeAskedAt = 0; closeMenu(); }
    }).observe(menu, { attributes: true, attributeFilter: ['class'] });
    if (isOpen()) focusFirst();
  })();
